import React, { useState, useRef, useEffect } from "react";
import "./Dropdown.scss";
import PropTypes from "prop-types";

Dropdown.propTypes = {
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default function Dropdown({
  name,
  value,
  className,
  dataValidationName,
  options,
  optionOnChange,
  onBlur,
  exclude,
  ...rest
}) {
  const [show, setShow] = useState(false);
  const [label, setLabel] = useState(false);
  const myRef = useRef();
  // To close count dropdown when clicking outside
  const handleClickOutside = (e) => {
    if (!myRef.current.contains(e.target)) {
      setShow(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  });

  !label &&
    value &&
    options &&
    options.filter((o) => (o.value == value ? setLabel(o.label) : ""));

  // to make the label changed if the value is empty
  label && !value && setLabel("");

  // To exclude dropdown values
  if (!exclude) {
    exclude = "";
  }
  return (
    <div className="d-flex ai-center">
      <ul className="cmn-dropdown" ref={myRef} onClick={() => setShow(!show)}>
        <input
          type="hidden"
          name={name}
          value={value}
          data-validation-name={dataValidationName}
        />
        <li onBlur={onBlur}>
          <button
            className={`${className ? className : ""} ${
              show ? "bor-ylw" : ""
            } ${!label ? "ph-select" : ""}`}
            type="button"
            {...rest}
          >
            {label ? label : ""}
          </button>
        </li>
        <ul className={`dd-value ${show ? "dd-open" : "dd-close"}`}>
          {show && options && options.length
            ? options.map((o, i) =>
                o.label ? (
                  !exclude.includes(+o.label) ? (
                    <li
                      key={i}
                      onClick={() => {
                        setLabel(o.label);
                        optionOnChange(name, o.value);
                      }}
                    >
                      <span name={name} value={o.value}>
                        {o.label}
                      </span>
                    </li>
                  ) : null
                ) : (
                  ""
                )
              )
            : null}
        </ul>
      </ul>
    </div>
  );
}
